export default __webpack_public_path__ + "static/dev-54f9e26cc8d60ad2536ec730d11565c7.jpeg";